import { paraRota } from '../nucleo/rota.js';

/**
 * O índice do laboratório: três perguntas, não três formulários.
 *
 * Quem chega aqui não quer "usar o módulo de laboratório". Quer uma das três
 * coisas, e sabe qual: está com um ensaio rodando e quer saber se ele vale,
 * está com um laudo na mão e não sabe o que ele diz, ou não tem ensaio nenhum
 * e precisa de uma estimativa. O índice existe para a pessoa reconhecer a sua
 * pergunta em uma linha e sair daqui.
 *
 * Por isso o cartão é a pergunta, no português de quem pergunta, e o nome
 * técnico do método vem embaixo, em cinza. Um menu que dissesse "Boyle",
 * "Chandler & Jewell" e "VDI 4630" seria o índice do nosso código, não do
 * problema de ninguém.
 */
const PERGUNTAS = [
  {
    parte: 'prever',
    pergunta: 'Quanto este material deve render?',
    quando: 'Você não tem ensaio BMP e precisa de um número para seguir.',
    como:
      'Seis modelos da literatura rodam sobre a composição que você tiver. Cada um devolve ' +
      'o seu valor — e a discordância entre eles faz parte da resposta.',
  },
  {
    parte: 'conferir',
    pergunta: 'O ensaio que está rodando vale?',
    quando: 'O BMP está no fim e você precisa decidir se publica o número.',
    como:
      'Os critérios de validade da VDI 4630 e de Holliger et al. (2016): controle de celulose, ' +
      'dispersão entre replicatas, contribuição do branco e critério de parada.',
  },
  {
    parte: 'laudo',
    pergunta: 'O que este laudo está dizendo?',
    quando: 'Chegou uma caracterização com DQO, COT e DBO e você quer lê-la.',
    como:
      'A razão DQO/COT dá o estado de oxidação do carbono, que dá o teto de metano. Com DBO, ' +
      'sai também o veredito de biodegradabilidade.',
  },
];

export function Laboratorio() {
  return (
    <div className="empilha-largo">
      <section className="bloco">
        <h2 className="simulador__titulo">Laboratório</h2>
        <p className="afirmacao">
          O ensaio de BMP é a medida de referência do setor — e dois laboratórios medindo o
          mesmo material chegam a discordar de 21 a 33%. Tudo aqui é construído em torno
          desse número: ele é o piso contra o qual qualquer precisão tem de ser lida.
        </p>
      </section>

      <div className="empilha">
        {PERGUNTAS.map((p) => (
          <a className="cartao-pergunta" key={p.parte} href={paraRota('laboratorio', p.parte)}>
            <h3 className="rotulo-secao">{p.pergunta}</h3>
            <p className="ficha__linha">{p.quando}</p>
            <p className="terciario">{p.como}</p>
          </a>
        ))}
      </div>

      <section className="bloco">
        <h3 className="rotulo-secao">O que este módulo não faz</h3>
        <p className="terciario">
          Nenhuma das três telas substitui o ensaio. A previsão por composição é a mais
          tentadora e a mais frágil: Ziero et al. (2026) testaram 13 modelos sobre 10 resíduos
          e, das 650 combinações, uma foi excelente e 28 foram inaceitáveis — uma delas
          devolvendo BMP negativo. O que se faz aqui é mostrar o desacordo, não escondê-lo
          atrás de uma média.
        </p>
      </section>
    </div>
  );
}
